












import {Component, Vue} from "vue-property-decorator";
import KInput from "../components/KInput.vue";
import axios from "axios";

@Component({
    components: {KInput},
})
export default class Login extends Vue {
    private username!: string;
    private password!: string;

    protected login(evt: MouseEvent) {
        axios.post(process.env.VUE_APP_ROOT_API + "/token", {
            username: this.username,
            password: this.password,
        }, {withCredentials: true}).then((res: any) => {
            localStorage.auth_xsrf = res.data.xsrfToken;
            localStorage.auth_expires = res.data.expires;
            localStorage.auth_refresh = res.data.refresh;

            window.location.pathname = "/calendar";
        });
    }
}
